import { memo } from 'react';
import { EApplicantOfferPGKeys } from 'types';
import { TableCellProps } from '../../../types';
import { Flex } from '@chakra-ui/react';
import { defaultHeaderRenderer } from '../../headers';
import { IColumn } from '../../types';
import { UNKNOWN_VALUE } from '../helpers';
import { formatDate } from 'shared-components';

const Formatter = memo(function formatter(cellProps: TableCellProps) {
  const dateStr = cellProps.row.issueDate;

  const result = dateStr ? formatDate(dateStr) : UNKNOWN_VALUE;

  return (
    <Flex height="100%" width="100%" flexDirection={'column'}>
      {result}
    </Flex>
  );
});

export const IssuedDateColumn = (): IColumn => ({
  item: {
    key: EApplicantOfferPGKeys.ISSUE_DATE,
    name: 'Offer issued',
    headerRenderer: defaultHeaderRenderer,
    width: 'minmax(128px, 1fr)',
    sortable: true, // row not implemented in backend
    formatter: Formatter,
  },
  visible: () => true,
});
